import request from '@/utils/request'

export function fetchTodayStats() {
  return request.get('/api/stats/today')
}

export function fetchDailyStats(params = {}) {
  return request.get('/api/stats/daily', {
    params
  })
}

export function deleteDailyStats(ids) {
  return request.delete('/api/stats/daily', {
    data: { ids }
  })
}
